import { render, staticRenderFns } from "./NavigationAccountExpandCollapse.vue?vue&type=template&id=4fa302a7&scoped=true&"
import script from "./NavigationAccountExpandCollapse.vue?vue&type=script&lang=js&"
export * from "./NavigationAccountExpandCollapse.vue?vue&type=script&lang=js&"
import style0 from "./NavigationAccountExpandCollapse.vue?vue&type=style&index=0&id=4fa302a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa302a7",
  null
  
)

export default component.exports